module.exports = __webpack_public_path__ + "img/programme1.6c4597ce.png";